import React, { useEffect } from "react";
import { authInstance } from "../config/firebaseConfig";

import { useNavigate } from "react-router-dom";
import { useUser } from "../Contexts/UserProvider";

function SignoutPage() {
  const navigate = useNavigate();
  // const { user } = useUser();

  useEffect(() => {
    const signout = async () => {
      // if (user === null) {
      //   navigate("/get-started");
      // }

      authInstance.signOut();
      navigate("/get-started");
    };

    signout();
    // eslint-disable-next-line
  }, []);
  return <div className="p-5 min-h-screen">Signing out...</div>;
}

export default SignoutPage;
